import { render } from "./ConstructionItem.vue?vue&type=template&id=25afb9a8&scoped=true"
import script from "./ConstructionItem.vue?vue&type=script&lang=js"
export * from "./ConstructionItem.vue?vue&type=script&lang=js"

import "./ConstructionItem.vue?vue&type=style&index=0&id=25afb9a8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25afb9a8"]])

export default __exports__